var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.items),function(item,index){return [_c('menu-item',_vm._b({key:index},'menu-item',item,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }